import api from "./api";

// Form types are tenant-editable data rather than a hard-coded list. Reading is
// ungated — every picker and list needs it to turn a stored formType id into a
// name — while every mutation requires formConfig:manageTypes.
const getAll = (includeInactive = false) => {
  return api.get("/api/form-type", {
    params: includeInactive ? { includeInactive: "true" } : {},
  });
};

const create = (data) => {
  return api.post("/api/form-type", data);
};

const update = (id, data) => {
  return api.patch(`/api/form-type/${id}`, data);
};

// Retiring a type hides it from the pickers but leaves it resolvable, because
// forms that recorded it still reference it by id. There is no delete.
const archive = (id) => {
  return api.patch(`/api/form-type/${id}/archive`);
};

const restore = (id) => {
  return api.patch(`/api/form-type/${id}/restore`);
};

const FormTypeService = { getAll, create, update, archive, restore };

export default FormTypeService;
